import KuanshiIcon from '../../../../static/img/kuanshi.png'
import SucaiIcon from '../../../../static/img/sucai.png'
import TuyaIcon from '../../../../static/img/tuya.png'
import WenziIcon from '../../../../static/img/wenzi.png'
import ShangwuIcon from '../../../../static/img/shangwu.png'
import PluginsContext from '../context'
import TContext from '../../context'
import { useContext, LegacyRef, useRef, useImperativeHandle, useState, useEffect } from 'react'

export const Height = 56

export const foot: React.CSSProperties = {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    height: Height,
    background: '#ffffff',
    boxShadow: '0px -1px 5px 0px rgba(0,0,0,0.10)',
    zIndex: 10,
    justifyContent: 'space-around',
    alignItems: 'center',
    left: 0,
    //paddingBottom: 'constant(safe-area-inset-bottom)',//兼容 IOS<11.2
    paddingBottom: 'env(safe-area-inset-bottom)'//兼容 IOS>11.2
}

export const foot_item = {
    margin: '0 auto',

}

export const foot_txt: React.CSSProperties = {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(51, 51, 51, 1)',
    textAlign: "center",
    marginTop: 4
}

export const iconStyle = {
    width: 30,
    height: 30
}

interface option {
    icon: string
    text: string
    key: MenuType
    hidden: boolean
    iconClass?: string
    // handle: React.MouseEventHandler
}

export interface Props {
    onClick?: any
    cutpartList?: cutpartListItem[]
    swiperClient?: any
    editText?: boolean
    action?: any
}

interface cutpartListItem {
    code: string
    img: string
    show?: boolean
    camera?: any
}

export enum MenuType {
    KUANSHI = 1,
    SUCAI = 2,
    TUYA = 3,
    WENZI = 4,
    SHANGWU = 5,
    YANSHE = 6,
    CLIPPING = 7,

}

export const options: option[] = [
    // {
    //     icon: KuanshiIcon,
    //     text: "款式",
    //     key: MenuType.KUANSHI,
    //     hidden: false
    // },
    {
        icon: KuanshiIcon,
        text: "Colors",
        key: MenuType.YANSHE,
        hidden: false,
        iconClass: 'fpd-icon-layers'
    },
    {
        icon: SucaiIcon,
        text: "Images",
        key: MenuType.SUCAI,
        hidden: false,
        iconClass: 'fpd-icon-images'
    },
    // {
    //     icon: TuyaIcon,
    //     text: "Designs",
    //     key: MenuType.TUYA,
    //     hidden: false,
    //     iconClass: 'fpd-icon-design-library'
    // },
    {
        icon: WenziIcon,
        text: "Add Text",
        key: MenuType.WENZI,
        hidden: false,
        iconClass: 'fpd-icon-text-secondary'
    }
    // {
    //     icon: ShangwuIcon,
    //     text: "关于",
    //     key: MenuType.SHANGWU,
    //     hidden: false
    // }
]

export interface Action {
    getHeight?: () => number;
}


const Index = (props: Props) => {
    const pluginContext = useContext(PluginsContext)
    const tc = useContext(TContext)

    const contentRef: LegacyRef<HTMLDivElement> = useRef(null)
    const [filteredCutparts, setFilteredCutparts] = useState<any>(null);

    const getHeight = () => {
        return contentRef.current?.offsetHeight as number
    }

    useImperativeHandle(props.action, (): Action => ({
        getHeight
    }));
    useEffect(() => {
        const cutpart = tc?.detailData?.model_materials?.cutparts?.find((item: any) => {
            return item.code === tc?.curCutpartCode;
        });
        setFilteredCutparts(cutpart);
    }, [tc?.curCutpartCode, tc?.detailData?.model_materials?.cutparts]);
    return (
        <>
            <div ref={contentRef} style={{ display: 'flex', ...foot, }}>
                {
                    options?.map((v, index) => (
                        !v.hidden && <div style={{
                            ...foot_item,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: index == 0 ? 'pointer' : (filteredCutparts?.is_diy == 0 ? 'not-allowed' : 'pointer'),
                            opacity: index == 0 ? 1 : (filteredCutparts?.is_diy == 0 ? 0.5 : 1),
                            filter: index == 0 ? 'none' : (filteredCutparts?.is_diy == 0 ? 'grayscale(50%)' : 'none'),
                        }} key={v.key} onClick={(e) => {
                            if (index !== 0 && filteredCutparts?.is_diy == 0) {
                                e.stopPropagation();
                                return;
                            }
                            e.preventDefault()
                            pluginContext?.showPlugin!(v.key as MenuType)
                            //点击菜单按钮失去焦点
                            tc.curCanvasClient?.discardActiveObject()
                        }}>
                            <i
                                className={`${(v as any).iconClass}`}
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    // 定义 CSS 变量，供下面的伪类使用
                                    '--icon-font-size': '10px',
                                } as React.CSSProperties} // 类型断言解决 TS 报错

                            />
                            <div style={foot_txt}>{t(v.text)}</div>
                        </div>
                    ))
                }
            </div>
            <style>
                {`
          .fpd-icon-text-secondary::before {
            font-size: 22px;
          }
            .fpd-icon-images:before {
    font-size: 22px;
}

.fpd-icon-design-library:before {
    font-size: 22px;
}
.fpd-icon-text-layers:before {
    font-size: 22px;
}
        `}
            </style>
        </>
    )
}

export default Index
